module.exports = __webpack_public_path__ + "static/media/favicon.2e75ef87.ico";